import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Navigator from '../../../components/common/Navigator'
import Img1 from '../../../assets/facilitationMain.jpg'
import Img2 from '../../../assets/ApplicationSupport.jpg'
import Img3 from '../../../assets/ConsultingServices.jpg'
import Img4 from '../../../assets/Mentoring.jpg'
import Img5 from '../../../assets/ProjectReport.jpg'
import IncubationApplyBg from '../../../assets/facilitationbg.png'

import { Button, DialogModal } from '../../../components/common'
import { useAuthStore } from '../../../store/authStore'
import Icons from '../../../components/common/icons'
const Facilitation = () => {
  const { authenticated } = useAuthStore()
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false)

  // const handleApplyNow = () => {
  //   if (authenticated) {
  //     const roleName = roleData?.name?.trim() || ''

  //     if (roleName === 'aspering_ent') {
  //       navigate('/departments/facilitation/form')
  //     } else {
  //       setIsModalOpen(true) // open modal
  //     }
  //   } else {
  //     navigate('/login')
  //   }
  // }
  const handleApplyNow = () => {
    if (authenticated) {
      navigate('/departments/facilitation/form')
    } else {
      navigate('/login')
    }
  }

  return (
    <div className="lg:w-11/12 mx-auto bg-white py-8">
      <div className="pb-4">
        <Navigator title="Facilitation" slug="FACILITATION" />

        <h1 className="text-3xl font-semibold text-gray-900">Facilitation</h1>
        <p className="text-md text-gray-900 mb-4">
          Facilitation Services by KIED- Empowering MSMEs in kerala
        </p>
        <hr className="border-t-2 border-primaryBlue " />
      </div>

      <div className="flex flex-col md:flex-row justify-between gap-8 bg-white py-1 rounded-lg">
        {/* Left Section - Text */}
        <div className="w-full md:w-7/12 flex flex-col justify-between">
          {/* <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Executive Summary
            </h2>
            <p className="text-md text-gray-900 leading-relaxed text-justify">
              The Kerala Institute for Entrepreneurship Development (KIED) is
              proud to introduce a comprehensive set of facilitation services
              designed to empower Micro, Small, and Medium Enterprises (MSMEs)
              across the state. These services are aligned with our mission to
              promote entrepreneurship, foster innovation, and support the
              growth of Kerala’s vibrant MSME sector. Our initiatives are
              tailored to provide entrepreneurs with the tools, insights, and
              support they need to navigate today’s competitive business
              landscape.
            </p>
          </div> */}
          <div>
            {/* <h2 className="text-lg font-semibold text-gray-900 mb-2 mt-4">
              Introduction
            </h2> */}
            <p className="text-md text-gray-900 leading-relaxed text-justify">
              MSMEs play a crucial role in driving economic development and
              innovation. At KIED, we understand the unique challenges faced by
              entrepreneurs in this segment and are committed to strengthening
              Kerala’s entrepreneurial ecosystem. Our facilitation services are
              specifically crafted to address the evolving needs of MSMEs
              through expert consulting, customized mentoring, professional
              project report preparation, and end-to-end support with regulatory
              applications and government schemes.
            </p>
          </div>

          {/* <div className="flex justify-end">
            <Button
              onClick={handleApplyNow}
              label={'Application Form'}
              size="common"
              outlined
              className="w-40 border border-LightGreen text-LightGreen px-6 py-3 text-sm rounded hover:bg-LightGreen hover:text-white"
            />
          </div> */}
        </div>

        {isModalOpen && (
          <DialogModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            title="Permission Required"
            className=""
            body={
              <p className="pb-5">
                You do not have permission to access this form.
              </p>
            }
          />
        )}

        {/* Right Section - Image */}
        <div className="w-full md:w-4/12 flex justify-end">
          <img
            src={Img1}
            alt="Industry Academia Collaboration"
            className="rounded-lg object-cover w-full max-w-xl"
          />
        </div>
      </div>

      <h2 className="text-xl md:text-[36px] font-medium text-gray-900 text-center mb-10 mt-12 md:tracking-tighter">
        Our Facilitation Services
      </h2>
      <div className="bg-white transition duration-300 overflow-hidden mb-10 max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
          {/* Card 1 */}
          <div className="bg-white rounded-lg border border-BorderPink px-6 py-3">
            <h3 className="text-blue-600 text-lg font-semibold mb-4">
              Consulting Services
            </h3>
            <img
              src={Img3}
              alt="Consulting Services"
              className="w-full h-40 object-cover rounded-md mb-4 mt-8"
            />
            <h4 className="font-semibold text-gray-900 mb-2">
              We Aim To Establish A Dedicated Consulting Division Focused On:
            </h4>
            <ul className="list-disc list-inside text-gray-900 space-y-1 text-md">
              <li>
                Addressing the specific needs of both aspiring and existing MSME
                entrepreneurs.
              </li>
              <li>
                Offering strategic planning, business process optimization, and
                operational guidance.
              </li>
              <li>
                Enhancing business performance, scalability, and
                competitiveness.
              </li>
            </ul>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-lg border border-BorderPink px-6 py-3">
            <h3 className="text-blue-600 text-lg font-semibold mb-4">
              Tailored Mentoring
            </h3>
            <img
              src={Img4}
              alt="Tailored Mentoring"
              className="w-full h-40 object-cover rounded-md mb-4 mt-8"
            />
            <h4 className="font-semibold text-gray-800 mb-2">
              Our Mentoring Services Are Designed To Offer:
            </h4>
            <ul className="list-disc list-inside text-gray-900 space-y-1 text-md">
              <li>
                Ongoing support and expert guidance at various stages of the
                entrepreneurial journey.
              </li>
              <li>
                Help with business planning, financial management, licensing,
                market entry strategies, and more.
              </li>
              <li>
                Access to a network of experienced mentors—both internal and
                external—who provide sector-specific insights and foster
                professional growth.
              </li>
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-6 py-3">
          {/* Card 1 */}
          <div className="bg-white rounded-lg border border-BorderPink p-6 flex flex-col justify-between">
            <div>
              <h3 className="text-blue-600 text-lg font-semibold mb-4">
                Detailed Project Report (DPR) Preparation
              </h3>
              <img
                src={Img5}
                alt="Consulting Services"
                className="w-full h-40 object-cover rounded-md mb-4 mt-8"
              />
              <h4 className="font-semibold text-gray-800 mb-2">
                Our DPR services support entrepreneurs by:
              </h4>
              <ul className="list-disc list-inside text-gray-900 space-y-1 text-md">
                <li>
                  Preparing detailed and structured project reports required for
                  funding, subsidies, expansion, or launching new ventures.
                </li>
                <li>
                  Assisting with the entire process, including feasibility
                  studies, financial forecasting, and report documentation.
                </li>
              </ul>
            </div>

            {/* Button */}
            <div className="flex justify-end mt-6">
              <Button
                onClick={handleApplyNow}
                label="Application Form"
                size="common"
                outlined
                className="w-40 border border-LightGreen text-LightGreen px-6 py-3 text-sm rounded hover:bg-LightGreen hover:text-white"
              />
            </div>
          </div>
          {/* Card 4 - Application Support */}
          <div className="bg-white rounded-lg border border-BorderPink px-6 py-3 flex flex-col justify-between">
            <div>
              <h3 className="text-blue-600 text-lg font-semibold mb-4">
                Application Support for Registrations, Certifications, NOCs,
                Licenses & Government Schemes
              </h3>
              <img
                src={Img2}
                alt="Application Support"
                className="w-full h-40 object-cover rounded-md mb-4"
              />
              <h4 className="font-semibold text-gray-800 mb-2">
                We offer hands-on support to MSMEs for:
              </h4>
              <ul className="list-disc list-inside text-gray-900 space-y-1 text-md">
                <li>
                  Navigating the application processes for statutory
                  registrations, certifications, NOCs, licenses, and government
                  incentive schemes.
                </li>
                <li>
                  Ensuring compliance with eligibility criteria, regulatory
                  requirements, and submission timelines under both State and
                  Central Government programs.
                </li>
              </ul>
            </div>

            {/* Button */}
            <div className="flex justify-end mt-6">
              <Button
                onClick={handleApplyNow}
                label="Application Form"
                size="common"
                outlined
                className="w-40 border border-LightGreen text-LightGreen px-6 py-3 text-sm rounded hover:bg-LightGreen hover:text-white"
              />
            </div>
          </div>{' '}
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm mt-12 max-w-5xl mx-auto ">
        <div className="grid grid-cols-1 md:grid-cols-2">
          {/* Left Heading */}
          <div className="p-6 flex justify-start items-center">
            <h3 className="text-2xl font-medium text-gray-600">Key Services</h3>
          </div>
          {/* Right Heading */}
          <div className="p-6 flex justify-start items-center">
            <h3 className="text-2xl font-medium text-gray-600">
              What we offer
            </h3>
          </div>
        </div>

        {/* Row 1 */}
        {/* Row 1 */}
        <div className="border-t border-gray-200 mx-6">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="flex items-center gap-3 py-6">
              <span className="text-gray-900 text-xl">
                <Icons name="bulb-icon" />
              </span>
              <span className="text-gray-900 font-medium">
                Strategic Consulting
              </span>
            </div>
            <div className="p-6 text-md text-gray-900 space-y-1">
              <p>✔ Business strategy development & long-term planning</p>
              <p>✔ Process optimization for operational efficiency</p>
              <p>✔ Comprehensive market analysis & performance boosting</p>
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="border-t border-gray-200 mx-6">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="flex items-center gap-3 py-6">
              <span className="text-gray-900 text-xl">
                <Icons name="mentoring-icon" />
              </span>
              <span className="text-gray-900 font-medium">
                Tailored Mentoring
              </span>
            </div>
            <div className="p-6 text-md text-gray-900 space-y-1">
              <p>
                ✔ Personalized, stage-wise guidance from experienced mentors
              </p>
              <p>
                ✔ Support in business planning, finance, marketing, and
                compliance
              </p>
              <p>✔ Access to a wide mentor network within and beyond KIED</p>
            </div>
          </div>
        </div>
        {/* Row 3 */}
        <div className="border-t border-gray-200 mx-6">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="flex items-center gap-3 py-6">
              <span className="text-gray-900 text-xl">
                <Icons name="dpr-icon" />
              </span>
              <span className="text-gray-900 font-medium">DPR Preparation</span>
            </div>
            <div className="p-6 text-md text-gray-900 space-y-1">
              <p>
                ✔ Personalized, stage-wise guidance from experienced mentors
              </p>
              <p>
                ✔ Support in business planning, finance, marketing, and
                compliance
              </p>
              <p>✔ Access to a wide mentor network within and beyond KIED</p>
            </div>
          </div>
        </div>
        {/* Row 4 */}
        <div className="border-t border-gray-200 mx-6">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="flex items-center gap-3 py-6">
              <span className="text-gray-900 text-xl">
                <Icons name="app-support-icon" />
              </span>
              <span className="text-gray-900 font-medium">
                Application & Compliance Support
              </span>
            </div>
            <div className="p-6 text-md text-gray-900 space-y-1">
              <p>
                ✔ Help with registrations, licenses, NOCs, and certifications
              </p>
              <p>
                ✔ Application support for state/central government schemes and
                subsidies
              </p>
              <p>✔ Compliance guidance and document management</p>
            </div>
          </div>
        </div>
        {/* Row 5 */}
        <div className="border-t border-gray-200 mx-6">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="flex items-center gap-3 py-6">
              <span className="text-gray-900 text-xl">
                <Icons name="fees-icon" />
              </span>
              <span className="text-gray-900 font-medium">
                Affordable & Transparent Fees
              </span>
            </div>
            <div className="p-6 text-md text-gray-900 space-y-1">
              <p>
                ✔ All services are provided at government-approved rates,
                ensuring fairness, accessibility, and quality support for every
                entrepreneur.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative mt-12">
        <div
          className="hidden md:block absolute right-0 top-0 h-full w-full bg-cover bg-right rounded-xl"
          style={{
            backgroundImage: `url(${IncubationApplyBg})`,
          }}
        />
      </div>
    </div>
  )
}

export default Facilitation
